/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'brand/NG_ACTIVE': {
    width: 16,
    height: 16,
    viewBox: '0 0 126.77 108.73',
    data: '<path pid="0" _fill="currentColor" d="M24.26 13.76c.05 1.41.16 2.33.11 3.24-.31 6-.44 12-1.05 17.9a8.53 8.53 0 0 0 9.29 9.35c2.39-.23 4.77-.65 7.16-.65 4.93 0 9.86.31 14.78.28 1.94 0 2.74.69 2.75 2.5 0 2.41.11 4.82 0 7.22-.19 6.26.59 12.17 4.59 17.4 1.81 2.33 3.93 3.74 6.63 3.72 4.93 0 11.58-2.56 16.07.38 5.1 3.33 3.81 14.92 4.16 20.22.56 8.61 6.3 11.22 13.82 11.94 5.17.5 10.34.94 15.51 1.43 2.74.26 4.91-.95 6.89-2.64 2.7-2.3 2.29-6.92-1-8.14a29.43 29.43 0 0 0-7.35-1.39c-4.19-.43-8.4-.63-12.57-.93 0 0-2.33-28.58-4.76-31.55-7.26-8.88-24.82 4.39-25.86-11.87-.42-6.65 1.58-15.81-6-19.2-4.44-2-9.13-1.12-13.71-1.1-4.33 0-8.65.47-13.2-.83-1-.29.61-17 .53-18.88-.22-5.11-1.65-11.05-8-10.73-4.93.26-21.79-3.42-29.38.06A5.72 5.72 0 0 0 .01 6.86c-.18 8.84 24.12 3.54 24.25 6.9z"/>'
  }
})



// WEBPACK FOOTER //
// ./src/components/app-icons/brand/NG_ACTIVE.js